import "../css/app.scss";

import Header from "./components/header";
import Burger from "./components/burger";
import Map from "./components/map";
import Filter from './components/filter';

$(() => {
  const $header = $("header");
  if ($header.length) {
    new Header($header);
  }

  const $burger = $('[data-burger="el"]');
  new Burger($burger);

  const $map = $('[data-contact-map="el"]');
  if ($map.length) {
    new Map($map);
  }

  const $filter = $('[data-filter="wrap"]');
  if ($filter.length) {
    new Filter($filter);
  }
});
